@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../../../constants/spacing.module.less';

.connectingLoader {
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  height: inherit;
  justify-content: center;
  padding: 2rem 0;
  text-align: center;
}

.title {
  margin-bottom: 1rem;
}

.subtitle {
  margin-bottom: 2rem;
}

.iconContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2rem 0;
  width: 100%;
}

.iconWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 1px solid var(--gray-E4E5E7);
}

.gearIcon {
  width: 20px;
  height: 20px;
}

.marketplaceIcon {
  width: 30px;
  height: 30px;
}

.connectionLine {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 150px;
  margin: 0 1rem;
}

.line {
  background: var(--gray-E4E5E7);
  left: 0;
  height: 2px;
  position: absolute;
  right: 0;
  top: 50%;
  z-index: 1;
}

.spinner {
  background: var(--white);
  position: relative;
  height: 30px;
  width: 30px;
  z-index: 2;
}

.helpText {
  align-self: center;
  text-align: center;
}

.hidden {
  visibility: hidden;
}
